import React, { useContext, useEffect, useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';

import { VALIDA_PERMISSAO_RELATORIO_DASH } from 'services/Relatorio';
import { Context } from 'context/AuthContext';
import Extrato from './Extrato';
import ExtratoParcial from './ExtratoParcial';
import Produtividade from './Produtividade';

import './styles.scss';

const ContentRelatorios = () => {
  const { showLoader } = useContext(Context);

  const [showViewDash, setShowViewDash] = useState(null);

  const produtividade = 'produtividade';
  const extrato = 'extrato';
  const extratoparcial = 'extratoparcial';

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    (async () => {
      showLoader(true);

      const result = await VALIDA_PERMISSAO_RELATORIO_DASH();

      setShowViewDash(result?.value || false);

      if (result?.value || false) {
        setActiveTab(produtividade);
      } else {
        setActiveTab(extrato);
      }

      showLoader(false);
    })();
  }, []);

  return (
    <div className="content_relatorios">
      <h1 className="relatorio-title">RELATÓRIOS</h1>
      {showViewDash !== null && activeTab !== null && (
        <Tabs
          defaultActiveKey={showViewDash === true ? produtividade : extrato}
          onSelect={(tab) => {
            setActiveTab(tab);
          }}
        >
          {showViewDash === true && (
            <Tab eventKey={produtividade} title="Dashboard">
              <div className="text-center iframe-container">
                {activeTab === produtividade && <Produtividade />}
              </div>
            </Tab>
          )}
          <Tab eventKey={extrato} title="Extrato Mensal">
            {activeTab === extrato && <Extrato />}
            {/* <Extrato /> */}
          </Tab>
          <Tab eventKey={extratoparcial} title="Extrato Parcial">
            {activeTab === extratoparcial && <ExtratoParcial />}
            {/* <ExtratoParcial /> */}
          </Tab>
        </Tabs>
      )}
    </div>
  );
};

export default ContentRelatorios;
